<div class="d-flex justify-content-end mb-3">
  <button type="button" class="btn btn-primary" (click)="onCreate()">
    {{ 'announcement.list.create' | translate }}
  </button>
</div>

<table class="table table-hover">
  <thead>
    <tr>
      <th>{{ 'announcement.list.title' | translate }}</th>
      <th>{{ 'announcement.list.app-type' | translate }}</th>
      <th>{{ 'announcement.list.start-date' | translate }}</th>
      <th>{{ 'announcement.list.end-date' | translate }}</th>
      <th>{{ 'announcement.list.message' | translate }}</th>
      <th></th>
    </tr>
  </thead>

  <tbody>
    @for (row of rows(); track row.announcement.id) {
      <tr role="button" (click)="onEdit(row.announcement)">
        <td>{{ row.announcement.title }}</td>
        <td>{{ 'announcement.app-type.' + row.announcement.appType | translate }}</td>
        <td>{{ row.announcement.start_date | localDateFormat }}</td>
        <td>{{ row.announcement.end_date | localDateFormat }}</td>
        <td>{{ row.message }}</td>
        <td class="text-end">
          <lib-confirm-delete-announcement
            #confirmDelete
            [announcement]="row.announcement"
            (delete)="onDelete(row.announcement)"
          >
            <button
              type="button"
              class="btn btn-sm btn-link"
              (click)="$event.stopPropagation(); confirmDelete.openDeleteConfirm()"
            >
              <fa-icon [icon]="'trash'"></fa-icon>
              {{ 'buttons.delete' | translate }}
            </button>
          </lib-confirm-delete-announcement>
        </td>
      </tr>
    } @empty {
      <tr>
        <td colspan="6" class="text-center text-muted">{{ 'announcement.list.empty' | translate }}</td>
      </tr>
    }
  </tbody>
</table>
